<template>
  <div class="login-container">
    <el-card class="login-card">
      <h3 slot="header">拓疆设备绑定后台管理系统</h3>
      <el-form :model="loginForm"   :rules="loginRules" ref="loginForm" label-width="0px" class="login-form">

        <el-form-item prop="account">
          <el-input v-model="loginForm.username" placeholder="手机号/用户名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input type="password" v-model="loginForm.password" placeholder="密码" prefix-icon="el-icon-lock" @keyup.enter.native="handleLogin"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" style="width:100%;" @click="handleLogin">登 录</el-button>
        </el-form-item>

        <div class="login-footer">
          <el-link type="primary" @click="register">立即注册</el-link>
        </div>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from '../../utils/request'
import router from '../../router/index'
export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入手机号或用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleLogin () {
      var that = this
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          axios.get(`/data/login?username=${that.loginForm.username}&password=${that.loginForm.password}`).then(function (res) {
            console.log(res)
            if (res.code === 200) {
              const token = res.data
              localStorage.setItem('token', token)
              localStorage.setItem('username', that.loginForm.username)
              localStorage.setItem('flag', that.loginForm.username)
              router.push('/device/bind')
            } else if (res.code === 500) {
              that.$message.error(res.message)
            }
          })
        } else {
          this.$message.error('请完整填写登录信息')
          return false
        }
      })
    },
    register () {
      router.push('/register')
    }
  }
}
</script>

<style scoped>
  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-image: url('../../assets/images/signin-1.jpg'); /* 假设您的图片放在 src/assets/login_bg.jpg */
    background-size: cover; /* 确保背景图片覆盖整个容器 */
    background-position: center; /* 居中背景图片 */
    background-repeat: no-repeat; /* 不重复背景图片 */
    /*background-color: #f2f6fc;*/
  }
  .login-card {
    width: 400px;
    max-width: 90%;
  }
  .login-footer {
    display: flex;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue